import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Merged. Kept as a redirect rather than deleted: `/settings/*` is deep-linked
 * across apps, docs and desktop menus, so a deleted route is a 404 where a
 * redirect preserves the canonical Connections destination.
 */
export const Route = createFileRoute("/settings/devices")({
  beforeLoad: () => {
    throw redirect({
      to: "/settings/environments",
      replace: true,
    });
  },
});
